import { Component } from "@angular/core";
import { User } from "../../providers/user";
import { ViewController } from "ionic-angular/navigation/view-controller";
import { NavParams } from "ionic-angular/navigation/nav-params";

@Component({
  selector: "page-confirm",
  templateUrl: "confirm.html"
})
export class ConfirmPage {
  public code: string;
  public username: string;

  constructor(
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public user: User
  ) {
    this.username = navParams.get("username");
  }

  confirm() {
    console.log("Confirm " + this.username);
    this.user.confirmRegistration(this.username, this.code).then(() => {
      this.viewCtrl.dismiss();
      //this.navCtrl.push(LoginPage);
    });
  }

  resendCode() {
    this.user.resendRegistrationCode(this.username);
  }
}



// WEBPACK FOOTER //
// ./src/pages/confirm/confirm.ts